import type { CartDiscountType } from "@telia/teddy";
import type { ICartSubscriptionPrice, SubscriptionType } from "../models";
import { OFFERING_CODES_TO_HALF_PRICE, OfferingCode } from "../models";
import { isBroadbandCode } from "./subscriptionCodeUtils";

export const getDiscountedMonthlyPrice = (
    monthlyPrice: number | undefined,
    monthlyDiscount: number | undefined,
    firstYearDiscountAmount?: number,
): number | undefined => {
    if (!monthlyPrice) return monthlyPrice;
    return monthlyPrice - (monthlyDiscount ?? 0) - (firstYearDiscountAmount ?? 0);
};

export const calculateHardcodedDiscount = (
    priceData: ICartSubscriptionPrice | undefined,
    shouldNotGetFirstYearDiscount?: boolean,
    firstYearDiscountAmount?: number,
    isSummerCampaign2026Enabled?: boolean,
    itemId?: string,
    isSummerCampaignJunior2026Enabled?: boolean,
): CartDiscountType[] => {
    if (shouldNotGetFirstYearDiscount) {
        return [];
    }

    const subscriptionType = (itemId || "").split(".")[0] as SubscriptionType;
    const shouldHalfPrice = OFFERING_CODES_TO_HALF_PRICE.includes(subscriptionType);

    if (isSummerCampaignJunior2026Enabled && shouldHalfPrice) {
        const amountSubscription = priceData?.monthly?.amountSubscription;
        if (!amountSubscription) return [];
        const halfPrice = Math.round(amountSubscription / 2);
        return [{ id: "hardcoded", value: halfPrice, text: "Halv pris i et halvt år", badgeVariant: "success" }];
    }

    if (isSummerCampaign2026Enabled && isBroadbandCode((itemId || "") as OfferingCode)) {
        return [
            {
                id: "hardcoded",
                value: 0,
                text: "Dobbel data i 12 mnd.",
                badgeVariant: "success",
            },
        ];
    }

    if (isSummerCampaign2026Enabled && firstYearDiscountAmount) {
        return [
            {
                id: "hardcoded",
                value: firstYearDiscountAmount,
                text: `${firstYearDiscountAmount},- rabatt i 12 mnd.`,
                badgeVariant: "success",
            },
        ];
    }

    if (firstYearDiscountAmount) {
        return [{ id: "hardcoded", value: firstYearDiscountAmount, text: "Rabatt" }];
    }

    return [];
};
